import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import CommonButton from '~/common/components/Button';
import Flex from '~/common/components/Flex';
import Stack from '~/common/components/Stacks/Stack';
import VStack from '~/common/components/Stacks/VStack';
import theme from '~/theme/';

const showFormAnimation = keyframes`
 from {
  padding: 0;
  opacity: 0;
  border-width: 0;
  background-color: transparent;
  overflow: hidden;
 }
 50% {
  opacity: 0;
  overflow: hidden;
 }
 to {
  height: auto;
  padding: 1rem;
  opacity: 1;
  border-width: 0.1rem;
  overflow: visible;
  background-color: ${theme.colors?.gray[50]};
 }
 `;

const StyledVStack = styled<any>(VStack)`
  width: 100%;
  border: 0rem solid ${theme.colors?.blue[600]};
  margin-bottom: 2rem;
  opacity: 0;
  animation: ${showFormAnimation} 0.25s linear forwards;
`;

type Loan1003FormContainerProps = {
  children: React.ReactNode;
  onCloseClicked: (...args: any[]) => any;
  isLoading: boolean;
  onSaveClicked: (...args: any[]) => any;
  toggleErrors?: (...args: any[]) => any;
  clearFieldsClick?: (...args: any[]) => any;
  readOnlyMode?: boolean;
  disableSave?: boolean;
  summaryCategory?: string;
  extraActionButton?: React.ReactNode;
};

export default function Loan1003FormContainer({
  onCloseClicked,
  isLoading,
  onSaveClicked,
  toggleErrors,
  children,
  disableSave = false,
  readOnlyMode = false,
  extraActionButton,
}: Readonly<Loan1003FormContainerProps>) {
  return (
    <StyledVStack align={'flex-start'}>
      {children}
      <Stack width={'100%'} boxSizing="border-box">
        {!readOnlyMode && (
          <Flex sx={{ justify: 'space-between' }}>
            {extraActionButton ?? <Flex />}
            <Flex align={'center'} boxSizing="border-box" padding={'0rem 1rem'}>
              <CommonButton
                sx={{ marginLeft: '2rem' }}
                isPrimary={false}
                id="asset-cancel-save-btn"
                onClick={() => onCloseClicked()}
                aria-label="Cancel"
              >
                Cancel
              </CommonButton>
              <CommonButton
                marginLeft={'1rem'}
                isDisabled={disableSave}
                isPrimary={true}
                isLoading={isLoading}
                onClick={() => {
                  onSaveClicked();
                  toggleErrors?.();
                }}
                aria-label="Save"
              >
                Save
              </CommonButton>
            </Flex>
          </Flex>
        )}
      </Stack>
    </StyledVStack>
  );
}
